export default "__VITE_ASSET__CVEw$4Tp__"